import styles from "@/styles/BlurImageBackground.module.scss";
import classnames from "classnames";
import Image from "next/legacy/image";

export default function BlurImageBackground({
  item,
  children,
  className,
  imageOptions = {},
}) {
  const url = item.thumbnailUrl;
  return (
    <div
      className={classnames(styles.container, {
        [styles.carousel]: className === "carousel",
        [styles.title]: className === "title",
      })}
    >
      <div className={styles.background}>
        <figure>
          {!!url && (
            <Image
              src={url}
              alt={item.name}
              layout="fill"
              objectFit="cover"
              objectPosition="50% 50%"
              {...imageOptions}
            />
          )}
        </figure>
      </div>
      {children}
    </div>
  );
}
